import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home1 from "./pages";
import Home1RTL from "./pages/home1-rtl";
import { useLanguage } from "./common/hooks/use-language";

function App() {
  const _ = useLanguage();
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home1 />} />
        {/* <Route path="/home1" element={<Home1 />} /> */}
        <Route path="/ar" element={<Home1RTL />} />
      </Routes>
    </Router>
  );
}

export default App;
